<template>
  <module-list-layout :createAction="createAction" :module="module" class="p-2" v-if="amReady">

    <el-dialog :visible.sync="dialogVisible" title="" top="5vh" width="75%">
      <moduleForm
          :bindingForView="true"
          :dataToBind="dataToBind"
          :edit-mode="editMode"
          :formHeader="true"
          :isForCurrentActiveUser="false"
          :on-create-callback="afterCreate"
          :on-edit-callback="afterEdit"
          :profilesList="profilesList"
          :showPasswordField="showPasswordField"
          class="p-3"
          v-if="dialogVisible"></moduleForm>
    </el-dialog>

    <el-dialog :visible.sync="setProfitRateDialogVisible" title="" top="5vh" width="75%">
      <setProfileRateForm
          :bindingForView="true"
          :dataToBind="dataToBind"
          :edit-mode="false"
          :formHeader="true"
          :formTitle="'Set Profit Percent for \'' + selectedUsername +'\''"
          :on-create-callback="afterCreateProfitPercent"
          :on-edit-callback="afterEdit"
          :userId="selectedUserId"
          class="p-3"
          v-if="setProfitRateDialogVisible"></setProfileRateForm>
    </el-dialog>

    <el-dialog :visible.sync="setWorkingRatesDialogVisible" title="" top="5vh" width="75%">
      <setWorkingRates
          :bindingForView="true"
          :dataToBind="dataToBind"
          :edit-mode="false"
          :formHeader="true"
          :formTitle="'Set Working Destinations Rates For \'' + selectedUsername  + '\''"
          :on-create-callback="afterCreateProfitPercent"
          :on-edit-callback="afterEdit"
          :userId="selectedUserId"
          class="p-3"
          v-if="setWorkingRatesDialogVisible"></setWorkingRates>
    </el-dialog>

    <el-dialog :append-to-body="true" :visible.sync="viewUserTestsDialogVisible" title="" top="5vh" width="75%">
      <broadcastHistory
          :bindingForView="true"
          :dataToBind="dataToBind"
          :edit-mode="false"
          :formHeader="true"
          :formTitle="'Broadcast History for ' + selectedUsername "
          :on-create-callback="afterCreateProfitPercent"
          :on-edit-callback="afterEdit"
          :statusId="0"
          :userId="selectedUserId"
          class="p-3"
          v-if="viewUserTestsDialogVisible"></broadcastHistory>
    </el-dialog>

    <div class="row pl-3 pr-3">
      <div class="col-12 col-md-4 pt-1">
        <dg-text-field
            :field_span="19"
            :label_span="24"
            :liveUpdate="true"
            @amUpdated="userSearchUpdated"
            field_mark=""
            placeholder="search username or display name"></dg-text-field>
      </div>
      <div class="col-12 col-md-3">
        <dg-select-field
            :control="control"
            :field_span="19"
            :label_span="24"
            :options="profilesOptionsList"
            :translateLabels="false"
            field_mark=""
            label=""
            @amUpdated="filterByProfileUpdated"
            name="destination"
            placeholder="Filter By Profile"
            rules="required"></dg-select-field>
      </div>
      <div class="col-12 col-md-5 pt-1">
        <pagination
            :currentPage="currentPage"
            :margin-pages="2"
            :navigateHandler="navigateToPage"
            :page-count="getPagesCount()"
            :page-range="4"
            paginateClass=""></pagination>
      </div>
    </div>

    <app-ag-grid :agGrid="agGrid"></app-ag-grid>
  </module-list-layout>
</template>

<script>
import Vue from 'vue'
import actionsCell from './ag-grid/ActionsCell'
import userFusionServerName from './ag-grid/UserFusionServerName'
import module from './../../index.js'
import {notify} from '@/system-services/notify.js'
import {mapActions} from "vuex";

export default {
  components: {
    broadcastHistory: () => import('@/modules/voip-testing-panel/broadcast-history/page/View'),
    setProfileRateForm: () => import('@/modules/user-reseller-features/set-profit-rate/View'),
    setWorkingRates: () => import('@/modules/user-reseller-features/set-working-rates/View'),
    pagination: () => import('@/components/pagination/View.vue'),
    moduleForm: () => import('../../form/View'),
    moduleListLayout: () => import('@/modules-config/layouts/list/View.vue')
  },
  data() {
    return {
      profilesOptionsList: $store.state['user-state'].usersProfiles,
      userSearch: '',
      userSearchTimeOut: null,
      amReady: false,
      module: {
        ...module
      },
      showPasswordField: false,
      selectedUsername: ' - ',
      selectedUserId: null,
      setProfitRateDialogVisible: false,
      viewUserTestsDialogVisible: false,
      setWorkingRatesDialogVisible: false,
      currentPage: 1,
      pageChunkSize: 12,
      pageCount: 1,
      profilesList: [],
      editMode: false,
      dialogVisible: false,
      recordsCounter: 0,
      dataToBind: null,
      rowToEdit: null,
      filterByProfileId: '',
      agGrid: {
        pagination: false,
        enableRtl: this.$langConfig.dir == 'rtl',
        agGridStyle: 'width: 100%; height: 650px; padding: 0',
        agGridClass: 'ag-theme-material',
        gridOptions: {
          suppressCellSelection: true,
          onGridReady: function (params) {
            params.api.sizeColumnsToFit()
          }
        },
        columnDefs: [
          {
            field: 'display_name',
            headerName: 'Display Name',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          },
          {
            field: 'username',
            headerName: 'Username',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          },
          {
            field: 'profile_caption',
            headerName: 'Profile',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          },
          {
            field: 'email',
            headerName: 'Email',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          },
          {
            headerName: 'Fusion Server',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            cellRendererFramework: Vue.extend(userFusionServerName),
            cellRendererParams: {
              props: {
                actionsHandler: this.actionsHandler
              }
            }
          },
          {
            field: 'created_at',
            headerName: 'Created',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          },
          {
            width: 120,
            headerName: this.$ml.get('actions'),
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            cellRendererFramework: Vue.extend(actionsCell),
            cellRendererParams: {
              props: {
                actionsHandler: this.actionsHandler
              }
            }
          }
        ],
        rowData: []
      }
    };
  },
  beforeMount() {
    this.currentPage = parseInt(this.$route.params.listPage)
    this.getEntityListData(this.currentPage)
  },
  methods: {
    filterByProfileUpdated (inputField) {
      this.filterByProfileId = inputField.field.field_value
      this.getEntityListData(1)
    },
    getEntityListData(page) {
      this.getEntityList({page: page, search: this.userSearch, profileId: this.filterByProfileId}).then(response => {
        this.buildAgGridData(response)
      })
      this.currentPage = page
    },
    buildAgGridData(response) {
      this.agGrid.rowData = response.rows;
      this.recordsCounter = response.count;
      this.amReady = true
      this.getUsersFusionServer({records: response.rows}).then(response => {
        this.setStateUsers({key: 'usersFusionServers', value: response})
      })
    },
    userSearchUpdated(field) {
      let val = field.field.field_value
      this.userSearch = val
      clearTimeout(this.userSearchTimeOut)
      this.userSearchTimeOut = setTimeout(() => {
        this.getEntityListData(1) //this.agGrid.gridApi.setQuickFilter(val);
      }, 200)
    },
    ...mapActions('user-state', {setStateUsers: 'setState'}),
    ...mapActions('voip-testing-panel-api', {
      getUsersFusionServer: 'getUsersFusionServer',
    }),
    ...mapActions('user-api', {getEntityList: 'list'}),
    scrollToTop() {
      document.body.scrollTop = 0;
      document.getElementById('content-main-container').scrollTop = 0;
    },
    getPagesCount() {
      return Math.ceil(this.recordsCounter / this.pageChunkSize)
    },
    navigateToPage(page) {
      $router.push({name: 'module->user->list->page', params: {listPage: page}})
    },
    refreshGrid() {
      this.agGrid.gridOptions.api.setRowData(this.agGrid.rowData)
    },
    afterEdit(updatedData) {
      // getting a rowNode by index
      // this.agGrid.gridApi.getDisplayedRowAtIndex(0).setData({})
      this.agGrid.rowData[this.rowToEdit] = updatedData;
      this.dialogVisible = false;
      this.refreshGrid();
    },
    afterCreateProfitPercent() {
      this.setProfitRateDialogVisible = false
    },
    afterCreate(newEntity) {
      this.agGrid.rowData.push(newEntity);
      this.dialogVisible = false;
      this.refreshGrid();
    },
    viewUserTests(params) {
      this.viewUserTestsDialogVisible = true
      this.selectedUsername = params.data.username
      this.selectedUserId = params.data.id
    },
    setWorkingRates(params) {
      this.selectedUsername = params.data.username
      this.selectedUserId = params.data.id
      this.setWorkingRatesDialogVisible = true
    },
    setProfitRate(params) {
      this.selectedUsername = params.data.username
      this.selectedUserId = params.data.id
      this.setProfitRateDialogVisible = true
    },
    createAction(params) {
      this.showPasswordField = true;
      this.dialogVisible = true;
      this.editMode = false;
      this.dataToBind = null;
      this.rowToEdit = null;
      // this.$router.push({ name: 'esb-individual-teacher-view', params: { teacherId: params.data.id}})
    },
    editAction(params) {
      this.showPasswordField = false;
      this.editMode = true;
      this.dataToBind = params.data;
      this.rowToEdit = params.rowIndex;
      this.dialogVisible = true;
      // this.$router.push({ name: 'esb-individual-teacher-view', params: { teacherId: params.data.id}})
    },
    removeAction(params) {
      this.$store.dispatch(this.module.info.name + '-api/remove', {id: params.data.id}).then(response => {
        this.agGrid.rowData.splice(params.rowIndex, 1);
        this.refreshGrid();
        this.recordsCounter -= 1;
        notify({
          type: 'success',
          title: this.$ml.get('deleted'),
        });
      })
    },
    actionsHandler(command, params) {
      this[command](params)
    }
  }
}
</script>
